
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inkinds/[id]/wishlist",
      function () {
        return require("private-next-pages/inkinds/[id]/wishlist.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inkinds/[id]/wishlist"])
      });
    }
  